// Tamaño y facturación (decisión de Octavio, 13-oct-2026):
//  · Todo trabajo de hasta 40 h, del tipo que sea (INC, SOL o REQ), consume la bolsa / baseline.
//  · Todo lo que pase de 40 h es facturación adicional (evolutivo aparte).
//  · Un requerimiento de más de 180 h deja de ser ticket: se convierte en proyecto.
// El tipo NO depende de las horas: lo decide la naturaleza del trabajo (ver tickets.ts).
export const DEFAULT_SIZING = { bagMaxHours: 40, reqMaxHours: 180 };
/** Acepta configuraciones guardadas antes del cambio (solMaxHours). */
export function normalizeSizing(raw) {
    return {
        bagMaxHours: raw?.bagMaxHours ?? raw?.solMaxHours ?? DEFAULT_SIZING.bagMaxHours,
        reqMaxHours: raw?.reqMaxHours ?? DEFAULT_SIZING.reqMaxHours
    };
}
export const BILLING_LABEL = {
    bag: 'Consume bolsa',
    additional: 'Facturación adicional'
};
/** ¿Las horas salen de la bolsa o se facturan aparte? Aplica a cualquier tipo de ticket. */
export function billingFor(hours, t = DEFAULT_SIZING) {
    return hours <= t.bagMaxHours ? 'bag' : 'additional';
}
/** Un requerimiento cuyo estimado supera el umbral de proyecto debe convertirse. */
export const isProjectSized = (hours, t = DEFAULT_SIZING) => hours > t.reqMaxHours;
//# sourceMappingURL=sizing.js.map